/**
 * Meeting Provider Selector
 *
 * This file provides a hook that returns the appropriate meeting adapter
 * based on the current provider context (Dyte or LiveKit).
 */

import { useMeetingProvider } from 'contexts/MeetingProviderContext';
import { useDyteMeetingAdapter } from './DyteMeetingAdapter';
import { useLiveKitMeetingAdapter } from './LiveKitMeetingAdapter';
import type { IMeetingAdapter } from './MeetingAdapter';

/**
 * Hook that returns the appropriate meeting adapter based on the provider
 * @returns IMeetingAdapter implementation for the current provider
 *
 * @example
 * const adapter = useMeetingProviderAdapter();
 * const participants = adapter.participants.toArray();
 * const self = adapter.self;
 */
export const useMeetingProviderAdapter = (): IMeetingAdapter => {
  const { provider } = useMeetingProvider();

  if (provider === 'livekit') {
    return useLiveKitMeetingAdapter();
  }

  // Default to Dyte for backward compatibility
  return useDyteMeetingAdapter();
};
